import React, { useEffect, useState } from 'react';
import "../css/Events.css";
import { Dimmer, Loader, Dropdown, Grid, Icon, Modal, Image, Button, Card } from 'semantic-ui-react';
import EventModal from './EventModal';
import { useNavigate } from "react-router-dom";


let eventsMap;
let eventsFoundBool = true;

export default function Events() {
    let navigate = useNavigate();

    const [publicEventsList, setPublicEventsList] = useState([]);
    const [privateEventsList, setPrivateEventsList] = useState([]);
    const [RSOEventsList, setRSOEventsList] = useState([]);
    const [currEventType, setCurrEventType] = useState([]);
    const [eventCards, setEventCards] = useState([]);
    const [eventsFound, setEventsFound] = useState(true);
    const [location, setLocation] = useState({ lat: 28.6024274,  lng: -81.2000599 });
    const [loaded, setLoaded] = useState(false);


    const eventOptions = [
        {
          key: 0,
          text: 'Public Events',
          value: 'Public Events',
        },
        {
          key: 1,
          text: 'Private Events',
          value: 'Private Events',
        },
        {
          key: 2,
          text: 'RSO Events',
          value: 'RSO Events',
        }
    ]

    useEffect(() => {
        getPublicEvents();
        getPrivateEvents();
        getRSOEvents();
    }, []);

    useEffect(() => {
        const awaitingMapEvents = async() => {
            await mapEvents();
        }

        awaitingMapEvents();
    }, [currEventType]);

    const redirectLogin = () => {
        localStorage.clear();
        navigate("/");
    };

    const redirectUniversity = () => {
        navigate("/MyUniversity");
    };

    const redirectRSO = () => {
        navigate("/RSO");
    };

    const redirectMyRSO = () => {
        if (localStorage.getItem("adminorsuper") == 0)
            navigate("/MyRSOs");
        else
            navigate("/ApproveRSOs");
    };

    const redirectMyEvent = () => {
        navigate("/ApproveEvents");
    };

    const redirectEvent = () => {
        navigate("/Events");
    };

    return (
        <div className="ui center aligned padded grid">
            <div className="row events-row">
                <div className="events-blue-sidebar column three wide">
                    <h2 className="events-hi-user">Hi, {localStorage.getItem("first")}</h2>
                    <p className="events-subpage-link" onClick={redirectUniversity}>My University</p>
                    <p className="events-subpage-link" onClick={redirectMyRSO}>{(localStorage.getItem("adminorsuper") == 0) ? ("My RSOs") : ("Approve RSOs")}</p>
                    <p className="events-subpage-link" onClick={redirectMyEvent}>{(localStorage.getItem("adminorsuper") == 0) ? ("") : ("Approve Events")}</p>
                    <h2 className="events-sidebar-subtitle">EXPLORE</h2>
                    <p className="events-subpage-link" onClick={redirectRSO}>RSOs</p>
                    <p className="events-subpage-link" onClick={redirectEvent}>Events</p>
                    <Button icon onClick={redirectLogin}>
                        {(localStorage.getItem("adminorsuper") == 0) ? 
                            (<Icon className="event-icon" name='sign-out' size='large' />) :
                            (<Icon className="event-icon2" name='sign-out' size='large' />)}
                    </Button>
                </div>
                <div className="events-right-container column thirteen wide">
                    <div className='events-dropdown-container'>
                        <Dropdown
                            icon='angle down size big event-down-arrow'
                            className='events-event-dropdown'
                            options={eventOptions}
                            defaultValue={eventOptions[0].text}
                            onChange={(e) => getEvents(e.target.outerText)}
                        />
                    </div>
                    <div className='events-event-cards-container'>
                        {eventCards ? 
                            ((eventCards.length !== 0) ?
                                <Grid container columns={3} className='events-event-grid'>
                                    {eventCards}
                                </Grid> :
                            (<h3>No {currEventType} Going On</h3>))
                            :
                            <Dimmer inverted>
                                <Loader inverted content='Loading' />
                            </Dimmer>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
    
    async function mapEvents() {
        // console.log("events found: ", eventsFound);
        // if (eventsFound === false || eventsFoundBool === false) {
        //     console.log("No event records were found");
        //     eventsMap = <h3>No Events Found</h3>
        // }
        if (currEventType === "Public Events") {
            eventsMap = publicEventsList.map((event, idx) => {
                return (
                    <EventModal event={event} idx={idx} />
                );
            });
        }
        else if (currEventType === "Private Events") {
            eventsMap = privateEventsList.map((event, idx) => {
                return (
                    <EventModal event={event} idx={idx} />
                );
            });
        }
        else if (currEventType === "RSO Events") {
            eventsMap = RSOEventsList.map((event, idx) => {
                return (
                    <EventModal event={event} idx={idx} />
                );
            });
        }
        setEventCards(eventsMap);
    }
    
    function getEvents(eventType) {
        setEventCards(null);
        setCurrEventType(eventType);
    }

    async function getPrivateEvents() {
        try {
            let info = {
                userid: localStorage.getItem("userid")
                //uniid: localStorage.getItem("uniid"),
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listPrivateEvents.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            if (res.error != "") {
                console.log(res.error);
                setEventsFound(false);
                eventsFoundBool = false;
            }

            else {
                console.log(res.results);
                setPrivateEventsList(res.results);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function getRSOEvents() {
        try {
            let info = {
                userid: localStorage.getItem("userid")
                //uniid: localStorage.getItem("uniid"),
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listRSOEvents.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            if (res.error != "") {
                console.log(res.error);
                setEventsFound(false);
                eventsFoundBool = false;
            }

            else {
                console.log(res.results);
                setRSOEventsList(res.results);
            }
        } catch (error) {
            console.log(error);
        }
    }
    
    async function getPublicEvents() {
        try {
            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listPublicEvents.php",
                {
                    method: "GET",
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            if (res.error != "") {
                console.log(res.error);
                setEventsFound(false);
                eventsFoundBool = false;
            }

            else {
                console.log(res.results);
                setPublicEventsList(res.results);
                setCurrEventType("Public Events");
            }
        } catch (error) {
            console.log(error);
        }
    }
    
}
